import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon
} from '@material-ui/icons';
import SearchBox from '../../../../../common/SearchBox';
import { useSelectDriversContext } from '../SelectDriversContext';

const styles = (theme: {
  headerTextFontSize?: number;
  AppBGColor?: string;
  HeaderSelectedText?: string;
  iconColor?: string;
}) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.AppBGColor}`,
    padding: '10px',
    borderRadius: '4px 4px 0 0',
    fontStyle: 'normal',
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText,
  },
  maximizeIcon: {
    cursor: 'pointer',
    color: theme.iconColor,
    padding: 4,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});

export interface DriversGridHeaderProps {
  classes?: { headerStyle: string; maximizeIcon: string; headerActions: string };
}

const DriversGridHeader: React.FC<DriversGridHeaderProps> = ({ classes }) => {
  const { setQuickFilterText, maximizedPanel, setMaximizedPanel } = useSelectDriversContext();
  const isMaximized = maximizedPanel === 'grid';
  const toggleMaximize = () => setMaximizedPanel(isMaximized ? null : 'grid');

  return (
    <div className={classes?.headerStyle}>
      <span>Drivers</span>
      <div className={classes?.headerActions}>
        <SearchBox onChange={setQuickFilterText} />
        <span className={classes?.maximizeIcon} onClick={toggleMaximize} title={isMaximized ? 'Minimize' : 'Maximize'} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && toggleMaximize()}>
          {isMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </span>
      </div>
    </div>
  );
};

export default withStyles(styles)(DriversGridHeader);
